import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Booking from './pages/Booking/Booking';
import Info from './pages/Info/Info';
import Designs from './pages/Designs/Designs';
import Contact from './pages/Contact/Contact';
import DesignDetails from './pages/DesignDetails/DesignDetails';
import { initGA, logPageView } from './utils/analytics';

function App() {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    logPageView();
  }, [location]);

  React.useEffect(() => {
    // Disable right click
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Disable dragging of images
    const handleDragStart = (e) => {
      e.preventDefault();
    };

    // Disable keyboard shortcuts for saving images
    const handleKeyDown = (e) => {
      if (
        // Ctrl + S, Ctrl + U, Ctrl + Shift + I, F12
        (e.ctrlKey && (e.keyCode === 83 || e.keyCode === 85)) || 
        (e.ctrlKey && e.shiftKey && e.keyCode === 73) ||
        e.keyCode === 123
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-7xl mx-auto px-4 py-8 w-full">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/info" element={<Info />} />
          <Route path="/designs" element={<Designs />} />
          <Route path="/design/:id" element={<DesignDetails />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;